// ======================================================================
// File: usePurchaseRequestList.js
// Module: PPE → Procurement → Purchase Request
//
// Purpose:
// - Fetch PR list
// - Handle filters, pagination
// - Provide KPI counts
// ======================================================================

import { useEffect, useState } from "react";
import purchaseRequestService from "../services/purchaseRequestService";

export default function usePurchaseRequestList(filters = {}) {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [summary, setSummary] = useState({});
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
    total: 0,
  });

  // ==============================================================
  // LOAD DATA
  // ==============================================================
  const loadData = async (params = {}) => {
    setLoading(true);

    try {
      const response =
        await purchaseRequestService.getPurchaseRequests({
          page: pagination.page,
          page_size: pagination.pageSize,
          ...filters,
          ...params,
        });

      console.log("PR RESPONSE", response.data);

      // Backend Response:
      // {
      //   success: true,
      //   data: {
      //     data: [...],
      //     summary: {...}
      //   }
      // }

      const result = response?.data?.data || {};

      setRecords(result.data || []);
      setSummary(result.summary || {});

      setPagination((prev) => ({
        ...prev,
        total: result.summary?.total || 0,
      }));
    } catch (err) {
      console.error(
        "Failed to load purchase requests",
        err
      );

      setRecords([]);
      setSummary({});
    } finally {
      setLoading(false);
    }
  };

  // ==============================================================
  // EFFECT
  // ==============================================================
  useEffect(() => {
    loadData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.page]);

  // ==============================================================
  // PUBLIC API
  // ==============================================================
  return {
    loading,
    records,
    summary,
    pagination,
    setPagination,
    reload: loadData,
  };
}